"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserService = exports.UserServiceProvider = exports.UserContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const service_1 = require("../../service");
const typedi_1 = __importDefault(require("typedi"));
exports.UserContext = (0, react_1.createContext)(null);
function UserServiceProvider({ children }) {
    const user = typedi_1.default.get(service_1.User);
    return (0, jsx_runtime_1.jsx)(exports.UserContext.Provider, { value: user, children: children });
}
exports.UserServiceProvider = UserServiceProvider;
function useUserService() {
    const user = (0, react_1.useContext)(exports.UserContext);
    if (!user) {
        throw new Error('User service is not provided');
    }
    return user;
}
exports.useUserService = useUserService;
